import axios from 'axios'
import session from 'vue-cookies'
var baseUrl = "https://api.bertiebets.com/evaluations"
var key = session.get('bertiebets.admin.key')
export async function getEvaluations(criteria) {
  console.log(criteria)
  var url = baseUrl
  if (criteria) {
    url += "?"
    for (var criterium of criteria) {
      var criteriumKey =  Object.keys(criterium)[0]
      url += criteriumKey + '=' + criterium[criteriumKey]
    }
  }
    var response = await axios.get(url, {headers:{'x-api-key' : key}})
    if (response.status === 200) {
      return response.data
    }else {
      throw new Error(response)
    }
}
